import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

class SubscribeResult extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { i18n, t } = this.props;

        setTimeout(() => {
            window.location.href=`//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=${i18n.language}`;
        }, 10*1000);
    }

    render() {
        const { i18n, t } = this.props;
        //const result = location.result;

        const sectionId = '29,1096';
        const pageId = '29,1096';

        let lang = 'en';
        let googleLang = "en-US";
        if (i18n.language === 'TC') {
            lang = 'zh-hant';
            googleLang = "zh-HK";
        }

        window.jsMenu = {
            header: 'header',
            footer: 'footer',
            sidebar: 'sidebar',
            content: 'content',
            sectionId: sectionId,
            pageId: pageId,
            lang: lang,
            useCSS: true,
            overrideTopUrl: {
                en: `//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=EN`,
                zhHant: `//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=TC`,
                zhHans: `//${process.env['REACT_APP_SFCSC_DOMAIN']}/TuniS/${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=TC`
            }	
        };

        const { subscribeResult:status } = this.props.location.state;


        return (
            <>
                <Helmet>
                    <title>{t('form.title')}</title>
                    <script type="text/javascript" src={`//${process.env.REACT_APP_SFC_DOMAIN}/web/js-menu/menu.js`}></script>                    
                    <meta http-equiv="refresh2" content="5" url={`//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=${i18n.language}`}/>
                </Helmet>
                <div className="post" dangerouslySetInnerHTML={{__html:t(`result.${status}.message`)}}></div>
            </>
        );
    }
}

export default withRouter(withTranslation()(SubscribeResult));

